export default __webpack_public_path__ + "locales/zh-CN/Ldap.json?hash=333ccbc2de69fa368facbe2f130857a5";